import React, {useRef, useState} from 'react';
import {useDebounce} from "./useDebounce";

const useNotifications = () => {
    const notificationRef = useRef(null)
    const [notification, setNotification] = useState({
        success:false,
        msg:""
    })

    useDebounce(()=>{
        if(notification?.msg && notificationRef?.current){
            notificationRef.current?.toast()
        }
    }, 100, [notification])
    return {
        notificationRef,
        notification,
        setNotification
    }
};

export default useNotifications;